module.exports = __webpack_public_path__ + "static/img/ccs.c0ed6b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/ccs.jpg
// module id = F7Ac
// module chunks = 0